export const FLAGS = {
  hardwareEnabled: true,
} as const satisfies Record<
  string,
  boolean | string | number | { [key: string]: boolean }
>;

export type Flags = typeof FLAGS;
export type FlagKey = keyof Flags;

type Widen<T> = T extends boolean
  ? boolean
  : T extends string
    ? string
    : T extends number
      ? number
      : { [K in keyof T]: Widen<T[K]> };

export type FlagValues = { [K in FlagKey]: Widen<Flags[K]> };
